import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import { API_URL } from "../../../helpers/app_url";
import Swal from 'sweetalert2';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardHeader,
} from "reactstrap"
import { ToastContainer , toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import EligibilitypagesMenu from "../menu/eligibilitypages-menu";
import LeadEligibilityBreadcrumb from "components/Common/LeadEligibilityBreadcrumb";
import SaveButton from "components/buttons/save";
import axios from "axios";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import backIcon from "../../../assets/images/rsicons/backIcon.png"
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import SafeField from "helpers/SafeField";
class LeadEligibility extends Component {
  constructor(props) {
    super(props)
    this.state = {
       
        isRight:false,
        questions:''
    }
  
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
   
  }
  toggleAddNew() {
    this.setState({ isRight: !this.state.isRight });
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
}
componentDidMount() {
  
  this.fetchLocationQuestions();

}
// handleSubmit = (values, { setSubmitting }) => {
//   const submissionData = {
//     createQualificationBulkQuestionWithAnswersList: [
//       {
//         id: 0,
//         agentId: parseInt(localStorage.getItem("userId")),
//         weightage: parseInt(values.weightage),
//         question: "Location",
//         primaryScoringValue: parseInt(values.primaryScoringValue),
//         secondaryScoringValue: parseInt(values.secondaryScoringValue),
//         otherScoringValue: parseInt(values.otherScoringValue),
//         isActive: true,
//         questionAnswers: values.questionAnswers.map((answer) => ({
          
//             id: 0,
//             agentId: parseInt(localStorage.getItem("userId")),
//             questionId: 0,
//             answer: answer.answer,
//             scoringType: 1,
//             scoringValue: parseInt(answer.scoringValue),
//             isActive: true,

//         }))
//       },
//     ],
//   };
//   const obj = JSON.parse(localStorage.getItem("authUser"));
//   const token = obj.resultData.bearerToken;
//   const str = "Bearer " + token;
//   toast.loading("Please wait...")
//   axios.post(API_URL + `QualificationQuestion/AddUpdateQualificationBulkQuestionAnswers`, submissionData, {
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': str
//     }
//   })
//     .then(response => {
//       if (response.data.success == true) {
//         toast.dismiss();
//         toast.success("Location Saved");
//       }else{
//         toast.dismiss();
//         toast.success("Some error");
//       }
//     })
//     .catch(error => {
//       console.error('Error submitting form:', error);
//     })
//     .finally(() => {
//       setSubmitting(false);
//     });

// }
fetchLocationQuestions = () => {
  const userId = localStorage.getItem("userId");
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const authHeader = "Bearer " + obj.resultData.bearerToken;

  axios
    .get(`${API_URL}QualificationQuestion/allagentQualificationSpecificQuestionAnswers?agentId=${userId}&question=Location`, {
      headers: { Authorization: authHeader },
    })
    .then((res) => {
      if (res.data && res.data.length > 0) {
        const question = res.data[0];
        const locations = res.data;

        this.setState({
          locations: locations,
          questions: {
            id: question.id,
            qualificationQuestionId: question.qualificationQuestionId,
            weightage: question.weightage,
             answers: question.answers,
            primaryScoringValue: question.primaryScoringValue,
            secondaryScoringValue: question.secondaryScoringValue,
            otherScoringValue: question.otherScoringValue,
          },
        });
      } else {
        console.warn("No questions found in the response.");
      }
    })
    .catch((error) => {
      console.error("Error fetching questions:", error);
    });
};

 handleSubmit = (values, { setSubmitting }) => {
  const { questions } = this.state;

  const questionAnswers = (questions.answers || []).map((ans, index) => ({
    id: ans.id || 0,
    agentId: parseInt(localStorage.getItem("userId")),
    questionId: ans.questionId || questions.id || 0,
    answer: ans.answer,
    scoringType: 0,
    scoringValue: parseInt(values[`location${index + 1}`]) || 0,
    isActive: true,
  }));

  const submissionData = {
    createQualificationBulkQuestionWithAnswersList: [
      {
        id: questions.id || 0,
        agentId: parseInt(localStorage.getItem("userId")),
        weightage: parseInt(values.weightage),
        question: "Location",
        primaryScoringValue: parseInt(values.primaryScoringValue),
        secondaryScoringValue: parseInt(values.secondaryScoringValue),
        otherScoringValue: parseInt(values.otherScoringValue),
        isActive: true,
        questionAnswers,
      },
    ],
  };

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj.resultData.bearerToken;
  const str = "Bearer " + token;

  toast.loading("Please wait...");

  axios.post(API_URL + `QualificationQuestion/AddUpdateQualificationBulkQuestionAnswers`, submissionData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': str
    }
  })
    .then(response => {
      toast.dismiss();
      if (response.data.success) {
        toast.success("Weightage Saved");
      } else {
        toast.error("Some error occurred");
      }
    })
    .catch(error => {
      console.error('Error submitting form:', error);
      toast.dismiss();
      toast.error("Submission failed");
    })
    .finally(() => {
      setSubmitting(false);
    });
};


  handleLocationSubmit = (values, { setSubmitting, resetForm }) => {
    const submissionData = {
        agentId: parseInt(localStorage.getItem('userId')),
        questionId: parseInt(values.questionId),
        answer: values.answer,
        scoringType: parseInt(values.scoringType),
        scoringValue: parseInt(values.scoringValue),
        isActive: true
    };
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = "Bearer " + token;
    toast.loading("Please wait...")
    axios.post(API_URL + `QualificationQuestionAnswer`, submissionData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': str
      }
    })
      .then(response => {
        if (response.data.success == true) {
          toast.dismiss();
          toast.success("Saved successfully");
            this.fetchLocationQuestions();
          resetForm({
          values: {
            agentId: parseInt(localStorage.getItem("userId")),
            questionId: values.questionId,
            answer: '',
            scoringType: 1,
            scoringValue: submissionData.scoringType === 1
              ? this.state.questions?.primaryScoringValue
              : this.state.questions?.secondaryScoringValue,
            isActive: true
          }
        });
        } else {
          toast.dismiss();
          toast.success("Some error");
        }
      })
      .catch(error => {
        console.error('Error submitting form:', error);
      })
      .finally(() => {
        setSubmitting(false);
      });

  }
 handleDelete = (answer) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You won\'t be able to revert this!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = "Bearer " + token;
      axios
        .delete(`${API_URL}QualificationQuestionAnswer/${answer?.id}`, {
          headers: {
            Authorization: str,
          },
        })
        .then((res) => {
          if (res.data.success) {
            Swal.fire('Deleted!', 'The location has been deleted.', 'success');
            this.fetchLocationQuestions();
          } else {
            Swal.fire('Error', 'Failed to delete.', 'error');
          }
        })
        .catch((err) => {
          console.error(err);
          Swal.fire('Error', 'Something went wrong.', 'error');
        });
    }
  });
};
  render() {
    const {questions, locations}  = this.state;
    
      return (
      <React.Fragment>
       
        <ToastContainer autoClose={2000} />
      
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Eligibility Questions | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">


            <Row className="mb20 project-header">
              <Col xl="6">
                <LeadEligibilityBreadcrumb
                  title={this.props.t("Lead")}

                  breadcrumbItem={this.props.t("Eligibility Questions")}
                />

              </Col>

            </Row>
             
            <Row>
              

              <Col xl="12">
              
                      <Card>
                        <CardBody>
                        <EligibilitypagesMenu />
                         
                        <Row className="align-items-stretch">
                            <Col sm="5">
                            
                            <Formik
                  enableReinitialize={true}
                  initialValues={{
                    agentId:parseInt(localStorage.getItem("userId")),
                    weightage:this.state.questions.weightage,
                    question: 'Location',
                    primaryScoringValue:this.state.questions.primaryScoringValue,
                    secondaryScoringValue:this.state.questions.secondaryScoringValue,
                    otherScoringValue:this.state.questions.otherScoringValue,
                    isActive:true,
                    questionAnswers: [],
                  }}
                  validationSchema={Yup.object().shape({
                    weightage: Yup.number().typeError("Must be a number").required("This is required"),
                    primaryScoringValue: Yup.number().typeError("Must be a number").required("This is required"),
                    secondaryScoringValue: Yup.number().typeError("Must be a number").required("This is required"),
                    otherScoringValue: Yup.number().typeError("Must be a number").required("This is required"),
    
                  })}

                  onSubmit={this.handleSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                              <Card className="border-brk mt-40">
                              <CardHeader>
                                <CardTitle>Step 1 : How important is a leads desired location is to you.</CardTitle>
                                <p> The &quot;location&quot; factor assesses the geographic area where the lead is interested in buying/renting.</p>
                               
                      <Row>
                       

                        <Col md="2">
                    <FormGroup className="mb-3">
                                       
                                        <SafeField
                                          name="weightage"
                                          className={
                                            "form-control" +
                                            (errors.weightage && touched.weightage
                                              ? " is-invalid"
                                              : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />
                                          <ErrorMessage
                                         name="weightage"
                                         component="div"
                                         className="invalid-feedback"
                                       />
                                       
                                      </FormGroup>
                    </Col>
                    <Col sm="10">
                          
                          (Assign a numerical value (1-10) to indicate how important location is in your overall lead evaluation. A higher value means higher importance.)
                         
                        </Col>
                      </Row>
                     </CardHeader>
                     </Card>
                     <Card className="border-brk mt-40">

                     <CardHeader>
                      <CardTitle>Step 2 :  Set a score for your service area(s) types </CardTitle>
                        <p>(Assign a numerical value (1-100) to indicate how important location is in your overall lead evaluation. A higher value means higher importance. The sum total could be greater than 100)</p>    
                     
                     
                    
                      <Row>
                    <Col md="2">
                    <FormGroup className="mb-3">
                                       
                                        <SafeField
                                          name="primaryScoringValue"
                                          className={
                                            "form-control" +
                                            (errors.primaryScoringValue && touched.primaryScoringValue
                                              ? " is-invalid"
                                              : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />
                                          <ErrorMessage
                                         name="primaryScoringValue"
                                         component="div"
                                         className="invalid-feedback"
                                       />

                                     
                                     </FormGroup>
                     
                    </Col>
                    <Col sm="10">
                          
                    For your Primary location which is your core services area
                         
                        </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                    <FormGroup className="mb-3">
                                       
                                        <SafeField
                                          name="secondaryScoringValue"
                                          className={
                                            "form-control" +
                                            (errors.secondaryScoringValue && touched.secondaryScoringValue
                                              ? " is-invalid"
                                              : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />
                                          <ErrorMessage
                                         name="secondaryScoringValue"
                                         component="div"
                                         className="invalid-feedback"
                                       />

                                     
                                     </FormGroup>
                     
                    </Col>
                    <Col sm="10">
                          
                    or your Secondary locations, which is not core but locations where you 
still service. your clients
                         
                        </Col>
                  </Row>
              
                    <Row>
                   
                  
                    <Col md="2">
                    <FormGroup className="mb-3">
                                       
                    <SafeField
                                          name="otherScoringValue"
                                          className={
                                            "form-control" +
                                            (errors.otherScoringValue && touched.otherScoringValue
                                              ? " is-invalid"
                                              : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />
                                          <ErrorMessage
                                         name="otherScoringValue"
                                         component="div"
                                         className="invalid-feedback"
                                       />
                                     </FormGroup>
                       
                    </Col>
                    <Col sm="10">
                    For all other locations. 
                        </Col>
                  </Row>

                  <SaveButton>Save</SaveButton>
                 </CardHeader>
                 </Card>
                 </Form>
                  )}
                            </Formik>
                            <div className="mt-4"><Link to="#" onClick={this.toggleAddNew} className="btn btn-light">Manage Location</Link></div>
                 
              </Col>
                    <Col sm="1" className="d-flex align-items-stretch justify-content-center">
                    <div className="vertical-line"></div>
                   </Col>

                   <Col sm="6">
                                              <div className="link-page">
                     
                      <div className="open-bg">
                        <h4><img src={img3} width="32px" /> Purpose</h4>
                            <ul className="no-list-type">
                              <li>The Location factor allows you to prioritize leads based on how well their area of interest aligns with your focus markets — helping you stay efficient and strategic with your time.  </li>

                               <li><strong>Step 1:</strong><br/>
                            Decide how important a lead’s preferred location is in your scoring model. 
                               
                               </li>

                                <li><strong>Step 2:</strong><br/>
                              Set scores for your Primary, Secondary, and Other location categories.
                                <ul>
                                  <li>   <strong>Primary Areas:</strong> Your highest priority zones — where you prefer to work, have listings, or run regular campaigns. </li>
                                   <li>   <strong>Secondary Areas: </strong> Locations you’re open to but are less central to your business.</li>
                                </ul>
                                </li>
 <li><strong>Step 3:</strong><br/>
                            Enter Your Primary and Secondary Areas 
                               <br/>
                               Enter the cities or regions you consider your Primary and Secondary service areas — typically the zones you actively farm or have strong market familiarity with. 
                               <br/>
                               Once you select these, all other locations will be automatically treated as “Other” and scored accordingly. 
                               </li>
                               
                            </ul>
                        
                      </div>
                      
                     {/* <Row>
                     {map(opfiles, (opfile, opfilekey) => (
                      <Col sm="2" key={ 'file_' + opfilekey}>
                        <h3 style={{fontSize:13}}>{opfile.documentName} <span className="float-end"><Link to="#" onClick={() => this.onClickDelete(opfile)}><i className="mdi mdi-close-circle"></i></Link></span></h3>
                      </Col>
                     ))}
                     </Row> */}

                     
                        </div>
                                              </Col>
            </Row>
            </CardBody>
            </Card>
            </Col>
            </Row>

            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleAddNew}
              style={{width:600}}
            >
              <OffcanvasHeader toggle={this.toggleAddNew}>
                Add Locations
              </OffcanvasHeader>
              <OffcanvasBody>
                  <Formik
                  enableReinitialize={true}
                  initialValues={{
                    
                        agentId:parseInt(localStorage.getItem("userId")),
                        questionId:questions?.id,
                        answer: '', 
                        scoringType: '',
                        scoringValue: questions?.primaryScoringValue,
                        isActive:true 
                    
                  }}
                  validationSchema={Yup.object().shape({
                   
                        answer: Yup.string().required("This is required"),
                        scoringType: Yup.string().required("This is required"),
                  })}
                   
                  onSubmit={this.handleLocationSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                             
                                    <Row>
                                      <Col sm="5">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`answer`}>
                                            {this.props.t("City/area name")}
                                          </Label>
                                          <SafeField
                                            name={`answer`}
                                            onChange={handleChange}
                                            type="text"
                                            className={
                                              "form-control" +
                                              (errors.answer &&
                                                touched.answer &&
                                                errors.answer &&
                                                touched.answer
                                                ? " is-invalid"
                                                : "")
                                            }
                                            id={`answer`}
                                          />
                                          <ErrorMessage
                                            name={`answer`}
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="4">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor={`scoringValue`}>
                                            {this.props.t("Type")}
                                          </Label>
                                            <SafeField
                                              name="scoringType"
                                              as="select"
                                              onChange={(e) => {
                                                const selectedType = parseInt(e.target.value);
                                                setFieldValue("scoringType", selectedType);
                                                setFieldValue(
                                                  "scoringValue",
                                                  selectedType === 1
                                                    ? questions?.primaryScoringValue
                                                    : questions?.secondaryScoringValue
                                                );
                                              }}
                                              className={
                                                "form-control" +
                                                (errors.scoringType && touched.scoringType ? " is-invalid" : "")
                                              }
                                              id="scoringType"
                                            >
                                              <option value="">Select Type</option>
                                              <option value="1">Primary</option>
                                              <option value="2">Secondary</option>
                                            </SafeField>
                                            <ErrorMessage
                                              name="scoringType"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                        </FormGroup>
                                      </Col>
                                      <Col sm="3">
                                             <button className="btn btn-save" type="submit" style={{marginTop:32}}>Save</button>
                                    
                                    </Col>
                                      
                                    </Row>
                                    <table className="table">
                                      <thead>
                                              <th>City</th>
                                              <th>Type</th>
                                              <th></th>
                                      </thead>
                                     {this.state.locations?.flatMap((location) => location.answers)?.map((answer, index) => (
                                        <tr key={answer.id}>
                                          <td>{answer.answer}</td>
                                           <td>{answer.scoringType==1 ? 'Primary' : 'Secondary'}</td>
                                          <td>
                                           <ActionDelete onClick={() => this.handleDelete(answer)} />
                                          </td>
                                        </tr>
                                      ))}
                                    </table>
            </Form>
                  )}
                  </Formik>
              </OffcanvasBody>
            </Offcanvas>

         
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
LeadEligibility.propTypes = {
  t: PropTypes.any,
 


}
const mapStateToProps = ({  }) => (
  {

    

  })
const mapDispatchToProps = dispatch => ({

   

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadEligibility))
